import { render, staticRenderFns } from "./PurchasesTreeTableFilters.vue?vue&type=template&id=06c08056&scoped=true"
import script from "./PurchasesTreeTableFilters.vue?vue&type=script&lang=js"
export * from "./PurchasesTreeTableFilters.vue?vue&type=script&lang=js"
import style0 from "./PurchasesTreeTableFilters.vue?vue&type=style&index=0&id=06c08056&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c08056",
  null
  
)

export default component.exports